exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".post-container {\n  border-bottom: 1px solid #cdd3d8;\n  padding-bottom: 15px;\n  padding-top: 15px;\n  padding-bottom: 2.5vw;\n  padding-top: 2.5vw;\n}\n.post {\n  margin-bottom: 5vh;\n}\n.metadata {\n  font-size: 80%;\n}\n.metadata .block {\n  display: block;\n}\n.metadata .timestamp {\n  font-style: italic;\n  color: rgba(96,125,139,0.5);\n  border: 1px solid rgba(96,125,139,0.1);\n  border-radius: 1.25vh;\n  line-height: 2.5vh;\n  padding: 0 2vh;\n  background-color: rgba(96,125,139,0.03);\n}\n.metadata .timestamp .timePart {\n  display: inline;\n}\n", ""]);

// exports
